import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';

import { HeaderService } from 'src/app/system-common/services/header.service';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { FinanceService } from '../services/finance.service';
import { PaymentStatementSearchHandler } from './payment-statement-search.handler';

@Component({
  selector: 'sym-payment-statement-search',
  templateUrl: './payment-statement-search.component.html',
  styleUrls: ['./payment-statement-search.component.scss'],
})
export class PaymentStatementSearchComponent extends PaymentStatementSearchHandler implements OnInit {

  constructor( 
    public service: FinanceService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ){
    super(service, headerService, router, settingService);
  }
  
  ngOnInit() {
  super.ngOnInit();
  }
}
